import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { G_TagsTypeViewModel } from 'src/app/viewmodels/g-settings/G_TagsTypeViewModel';
import { G_TagsViewModel } from 'src/app/viewmodels/g-settings/G_TagsViewModel';
import { AppConsts } from 'src/app/common/app-consts';
import { ItemViewModel } from 'src/app/viewmodels/ItemViewModel';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { SaveGCustomerRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  modalRefLv3: BsModalRef;
  public itemVm: SaveGCustomerRequest = new SaveGCustomerRequest();
  public vmListItems: any = [];
  public SortBy: string = "asc";
  public component_Title = 'Manage Customer';
  public tagTypes: any = [];

  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';
  flag = '';

  public deleteId: string;


  @Input('dataTable') table;
  dataTable: any;
  dtOption: any = {};

  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.flag = AppConsts.CUSTOMER;

    this.getList();
    $('table.display').DataTable();
    //    this.dtOption = {
    //      "paging":   false,
    //      "searching": false,
    //      "info": false,
    //  };
    //  $(() =>{
    //    $('table.display').DataTable(this.dtOption);
    //  })
  }

  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRefLv1 = this._modalService.show(template);
      this.modalRefLv1.setClass('modal-lg');
    }

    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
    if (lvl == 3) {
      this.modalRefLv3 = this._modalService.show(template);
    }
  }

  ngAfterViewInit() {
    // this._jq.showSpinner();
  }

  getList() {
    this.spinner.show();
    debugger
    const search = { Name: this.searchTerm }; // adapt per page
    this._uow.gSettingService.getList("GSetting", "GetGCustomersAsync", this.p, this.size, search, this.orderBy, this.sort, this.flag)
      .subscribe({
        next: (res: any) => {
          debugger
          this.vmListItems = res.result;
          this.totalItems = res.total;
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        }
      });
  }

  // called when user types in search box
  getBySearchTerm(event: any) {
    debugger
    this.searchTerm = event.target.value.trim();
    this.p = 1; // reset to first page
    this.getList();
  }

  // pagination handler
  onPageChange(page: number) {
    debugger
    this.p = page;
    this.getList();
  }

  // sorting handler (toggle Asc/Desc)
  getSortIndexList(column: string) {
    this.orderBy = column;
    this.sort = this.sort === 'Asc' ? 'Desc' : 'Asc';
    this.getList();
  }



  // getList() {
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   debugger
  //   this._uow.customerService.GetList().subscribe((res: any) => {
  //     this.vmListItems = res.DtlList;
  //     console.log(res);
  //     this.spinner.hide();
  //     // this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     // this._jq.showSpinner();
  //     this.spinner.hide();
  //     Swal.fire(
  //       'Failure!',
  //       'Network Issue!',
  //       'error'
  //     )
  //   });
  // }
  // getSortIndexList(sIndex) {
  //   debugger
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   this.SortBy = this.SortBy == "asc" ? "desc" : "asc";
  //   this._uow.customerService.GetPagedResult(0, 50, AppConsts.CUSTOMER, sIndex, this.SortBy).subscribe((res: any) => {
  //     debugger
  //     this._jq.reinitDataTable(res);
  //     this.vmListItems = res.DtlList;;
  //     console.log(res);

  //     // this._jq.showSpinner();
  //     this.spinner.hide();
  //   }, (err) => {
  //     console.log(err);
  //     this.spinner.hide();
  //   });
  // }
  // public searchTerm = '';
  // getBySearchTerm(e) {
  //   if (this.searchTerm !== ' ') {
  //     // this._jq.showSpinner(true);
  //     this.spinner.show();
  //     this._uow.customerService.GetPagedBySearch(this.searchTerm).subscribe((res: any) => {
  //       this.p =1;
  //       this.vmListItems = res.DtlList;
  //       // this._jq.showSpinner();
  //     this.spinner.hide();

  //     }, (error) => {
  //       console.log(error);
  //       // this._jq.showSpinner();
  //     this.spinner.hide();

  //     });
  //   } else {
  //     this.getList();
  //   }
  // }
  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    if (model !== undefined) {
      this.itemVm = model;
      debugger
      let test = this.itemVm.cpCell.split('-');
      if (test.length == 2) {
        this.itemVm.cpCell = test[1].toString();
        this.itemVm.countryCode = test[0].toString();
      }
      this.openModal(template, 1);
    } else {
      this.itemVm = undefined;
      this.openModal(template, 1);
    }
  }


  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
      this.deleteId = model.uniqueId;
    }
  }
  conformDelete() {
    this.spinner.show();
    this._uow.gSettingService.DeleteGCustomerAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRefLv1.hide();
      this.spinner.hide();
    }, (err) => {
      // this._jq.showSpinner();
      this.spinner.hide();
    });
  }

  // external components
  onItemTypeSubmitted(e) {
    if (e == true) {
      this.getList();
      this._jq.showSpinner(false);
    }
  }

}
